import * as React from 'react';
import styled from 'styled-components';

import { Card, CardMedia, ButtonBase } from '../material-ui';

const Wrapper = styled(Card)`
	margin: 0.5rem;
	width: ${(p) => p.width}rem;
	height: ${(p) => (p.width / 2) * 3}rem;
	cursor: ${(p) => (p.onClick ? 'pointer' : 'auto')};
	background: lightgray;
`;

const Image = styled(CardMedia)`
	width: 100%;
	height: 100%;
`;

const Ripple = styled(ButtonBase)`
	width: 100%;
	height: 100%;
`;

export class Poster extends React.Component {
	static defaultProps = { width: 6 };

	handleClick = () => {
		const { onClick, title, id, poster } = this.props;
		if (onClick) onClick({ title, id, poster });
	};

	render = () => (
		<Wrapper onClick={this.handleClick} width={this.props.width}>
			<Image image={this.props.poster} title={this.props.title}>
				<Ripple />
			</Image>
		</Wrapper>
	);
}



// WEBPACK FOOTER //
// ./src/components/Poster.js